import React from 'react';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet, useThemeContext } from '../../../hooks';
import { View } from '../../View';
import { IconButton } from '../../IconButton';
import { Divider } from '../../Divider';
import { Progress } from '../../Progress';
import { Focusable } from '../../Focusable';
import { Icon } from '../../Icon';
import { Switch } from '../../Switch';
import { Text as UIText } from '../../Text';
import { Text } from 'react-native';
import { useFileInputContext, useMessageInputContext, useTextInputContext } from '../hooks';
import { EditorMode } from '../types';
export const Footer = ({ onOpenTemplates, onSaveTemplate, templatesEnabled, templates, richTextEnabled, bookingEnabled, onBook, onUpload, mode, setMode, onDismissSuggestion, isAssistantEnabled, isSuggestionUsed }) => {
    const styles = useStyleSheet(getStyles);
    const { size } = useThemeContext();
    const { isEmpty } = useTextInputContext();
    const { files, uploadProgress, processing } = useFileInputContext();
    const { showRichTextToolbar, setShowRichTextToolbar, send } = useMessageInputContext();
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.tools },
            templatesEnabled ? (React.createElement(React.Fragment, null,
                React.createElement(View, null,
                    React.createElement(IconButton, { value: 'add', onPress: () => {
                            if (onOpenTemplates)
                                onOpenTemplates();
                        }, type: 'secondary', accent: 'neutral', size: 'sm' }),
                    templates),
                React.createElement(Divider, { type: 'vertical', style: styles.divider }))) : null,
            React.createElement(IconButton, { value: 'upload-files', onPress: onUpload, type: 'tertiary', accent: 'neutral', size: 'sm' }),
            richTextEnabled ? (React.createElement(IconButton, { style: styles.withMargin, value: showRichTextToolbar ? 'text-active' : 'text', onPress: () => {
                    setShowRichTextToolbar((active) => !active);
                }, type: 'tertiary', accent: 'neutral', size: 'sm' })) : null,
            isAssistantEnabled ? (React.createElement(React.Fragment, null,
                React.createElement(Divider, { type: 'vertical', style: styles.divider }),
                React.createElement(View, { style: styles.assistant },
                    React.createElement(Switch, { icon: 'wand', onChange: (v) => {
                            if (setMode)
                                setMode(v ? EditorMode.ASSISTANT : EditorMode.REGULAR);
                        }, value: mode === EditorMode.ASSISTANT }),
                    React.createElement(UIText, { type: 'body', size: 'md', weight: 'semibold', style: styles.assistant__text }, "AI Assistant")))) : null),
        templatesEnabled ? (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { value: 'bookmark-add', onPress: () => {
                    if (onSaveTemplate)
                        onSaveTemplate();
                }, type: 'tertiary', accent: 'neutral', size: 'sm', disabled: isEmpty }),
            React.createElement(Divider, { type: 'vertical', style: styles.divider }))) : null,
        isEmpty && !files.length && bookingEnabled ? (React.createElement(Focusable, { style: styles.button, hoverStyle: styles.button__isHovered, onPress: () => {
                if (onBook)
                    onBook();
            } }, ({ hovered }) => (React.createElement(React.Fragment, null,
            React.createElement(Text, { style: [
                    styles.button__text,
                    hovered ? styles.button__text__isHovered : {}
                ] }, "Book"),
            React.createElement(Icon, { name: 'calendar-add', color: (color) => color.white.p100, size: size.G }))))) : mode === EditorMode.ASSISTANT && isSuggestionUsed ? (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { value: 'thumbs-down', onPress: () => {
                    if (onDismissSuggestion)
                        onDismissSuggestion();
                }, type: 'secondary', accent: 'default', size: 'sm', disabled: (isEmpty && !files.length) || (!!files.length && processing) }),
            React.createElement(IconButton, { value: 'thumbs-up', onPress: () => {
                    send();
                }, type: 'secondary', accent: 'default', size: 'sm', disabled: (isEmpty && !files.length) || (!!files.length && processing), style: styles.thumbsUp }))) : (React.createElement(React.Fragment, null,
            React.createElement(IconButton, { value: 'arrow-up', onPress: () => {
                    send();
                }, type: 'primary', accent: 'default', size: 'sm', disabled: (isEmpty && !files.length) || (!!files.length && processing) }),
            !!files.length && processing && (React.createElement(Progress, { value: uploadProgress, radius: 49 / 2, outline: size.B, pointerEvents: 'none', style: {
                    position: 'absolute',
                    right: -5,
                    top: -5
                } }))))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        marginTop: size.C,
        alignItems: 'center'
    },
    tools: { flex: 1, flexDirection: 'row' },
    withMargin: {
        marginLeft: size.B
    },
    divider: {
        marginHorizontal: size.C,
        height: size.G,
        alignSelf: 'center',
        backgroundColor: color.invert2.p10
    },
    button: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: size.G,
        paddingVertical: size.D,
        backgroundColor: color.primary.solid,
        borderRadius: 9999
    },
    button__isHovered: { backgroundColor: color.primary.solidHover },
    button__text: {
        marginRight: size.B,
        color: color.white.p100,
        letterSpacing: -0.01,
        fontSize: size.E,
        lineHeight: size.G
    },
    button__text__isHovered: {
        color: color.white.p100
    },
    assistant: {
        padding: size.C,
        paddingRight: size.F,
        borderRadius: 9999,
        borderColor: color.invert2.p4,
        borderWidth: 1,
        flexDirection: 'row',
        alignItems: 'center'
    },
    assistant__text: {
        marginLeft: size.C,
        color: color.invert2.p68
    },
    thumbsUp: {
        marginLeft: size.B
    }
}));
//# sourceMappingURL=Footer.js.map